import CloseIcon from '@mui/icons-material/Close';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
} from '@mui/material';

interface Props {
    open?: boolean;
    onAccept?: () => void;
    onClose?: () => void;
}

export const AnonymousDialog = ({ open, onAccept, onClose }: Props) => {
    return (
        <Dialog
            open={Boolean(open)}
            onClose={onClose}
            scroll="paper"
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
            fullWidth
            maxWidth="sm"
        >
            <DialogTitle style={{ background: '#0c91c4', color: '#FFF' }}>
                <IconButton
                    sx={{
                        position: 'absolute',
                        top: '0px',
                        right: '10px',
                        color: 'white',
                    }}
                    aria-label="close"
                    onClick={onClose}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent
                dividers
                style={{ background: '#0c91c4', color: '#FFF' }}
            >
                Si usted registra la solicitud como anónimo, declara reserva
                sobre sus datos personales y de contacto, por lo tanto, debe
                tener en cuenta que la información a suministrar debe ser clara
                y completa, frente a la pretensión o los hechos a denunciar, lo
                anterior, con el fin de efectuar el trámite a que haya lugar.
            </DialogContent>
            <DialogActions
                style={{
                    background: '#0c91c4',
                    display: 'flex',
                    justifyContent: 'center',
                }}
            >
                <Button
                    variant="contained"
                    sx={{
                        backgroundColor: '#0576c3',
                        borderRadius: '8px',
                        width: '100px',
                        ':hover': {
                            backgroundColor: '#005a99',
                        },
                    }}
                    onClick={onAccept}
                >
                    Aceptar
                </Button>
            </DialogActions>
        </Dialog>
    );
};
